import { render, staticRenderFns } from "./inboundreport_main.vue?vue&type=template&id=631303dc&scoped=true"
import script from "./inboundreport_main.vue?vue&type=script&lang=js"
export * from "./inboundreport_main.vue?vue&type=script&lang=js"
import style0 from "./inboundreport_main.vue?vue&type=style&index=0&id=631303dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631303dc",
  null
  
)

export default component.exports